import React from "react";
import styled from "styled-components";

//
import LEFTIMG from "../../../assets/images/single-service-why-left.jpg";
import RIGHTIMG from "../../../assets/images/single-service-why-right.jpg";
import ICONEYEEXAMSTAT from "../../../assets/icons/eye-exam-stat.svg";
import ICONLASERSTAT from "../../../assets/icons/laser-stat.svg";
import ICONBLOGSTAT from "../../../assets/icons/blog-stat.svg";

export default function SingleServiceWhy() {
  return (
    <StyledSingleServiceWhy>
      <div className="container">
        <div className="single-service-why__wrap">
          <h1 className="single-service-why__title">
            Why <span>OptiOne Clinic?</span>
          </h1>
          <ul className="single-service-why__adv">
            <li>
              <div>
                <img src={LEFTIMG} alt="LEFTIMG" />
              </div>
              <h2>Highly Qualified Specialists</h2>
              <p>
                Ut sem viverra aliquet eget sit amet tellus cras. Nisl pretium
                fusce id velit. Sagittis aliquam malesuada bibendum arcu
              </p>
            </li>
            <li>
              <div>
                <img src={RIGHTIMG} alt="RIGHTIMG" />
              </div>
              <h2>Modern Ophthalmology</h2>
              <p>
                Velit ut tortor pretium viverra suspendisse potenti nullam ac.
                Quis hendrerit dolor magna eget est lorem ultrices
              </p>
            </li>
          </ul>
          <ul className="single-service-why__nums">
            <li>
              <div>
                <img src={ICONEYEEXAMSTAT} alt="ICONEYEEXAMSTAT" />
                <h3>25 000+</h3>
              </div>
              <p>Eye Examination and Сonsultation</p>
            </li>
            <li>
              <div>
                <img src={ICONLASERSTAT} alt="ICONLASERSTAT" />
                <h3>10 000+</h3>
              </div>
              <p>Performed Laser Surgical Corrections</p>
            </li>
            <li>
              <div>
                <img src={ICONBLOGSTAT} alt="ICONBLOGSTAT" />
                <h3>5 000+</h3>
              </div>
              <p>Online Appointment Processed by our Clinic</p>
            </li>
          </ul>
        </div>
      </div>
    </StyledSingleServiceWhy>
  );
}

const StyledSingleServiceWhy = styled.section`
  padding: 140px 0;

  .single-service-why {
    &__wrap {
    }

    &__title {
      color: var(--title);
      font-size: var(--fs-section-title);
      font-style: normal;
      font-weight: var(--fw-semibold);
      line-height: var(--lh-title);
      margin-bottom: 36px;

      span {
        color: var(--light-blue);
      }
    }

    &__adv {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      margin-bottom: 48px;

      li {
        div {
          line-height: 0;
          overflow: hidden;
          border: 1px solid var(--border);
          margin-bottom: 24px;

          img {
            width: 100%;
            height: auto;
            object-fit: cover;
          }
        }

        h2 {
          color: var(--title);
          font-size: var(--fs-card-title);
          font-style: normal;
          font-weight: var(--fw-semibold);
          line-height: 1.35;
          margin-bottom: 12px;
        }

        p {
          color: var(--text);
          font-size: var(--fs-body);
          font-style: normal;
          font-weight: var(--fw-regular);
          line-height: var(--lh-body);
          text-align: left;
        }
      }
    }

    &__nums {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 40px;

      li {
        background-color: var(--white);
        border: 1px solid var(--border);
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        padding: 50px;
        transition: 0.4s ease;

        div {
          display: flex;
          align-items: center;
          gap: 24px;

          h3 {
            color: var(--title);
            font-size: 42px;
            font-style: normal;
            font-weight: 600;
            line-height: 50px; /* 86.957% */
          }
        }

        p {
          color: var(--text);
        font-size: var(--fs-body);
          font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-body);
          opacity: 0.7;
          text-align: center;
          max-width: 250px;
        }

        &:hover {
          border-color: var(--light-blue);
        }
      }
    }
  }
`;
